<script>
    import EventBus from '../event-bus'
    import { debounce } from 'debounce'
    import { format } from 'date-fns'

    import Comments from '@/components/journal/Comments'

    export default {
        components: {
            Comments
        },
        props: {
            user: String,
            form: {
                type: Object
            },
            viewOnly: {
                type: Boolean
            },
            to: {
                type: Object
            },
            from: {
                type: Object
            }
        },
        watch: {
            'form.PositiveFeedback' (value) {
                this.updateParent(value)
            },
        },
        methods: {
            updateParent: debounce(function(val) {
                EventBus.$emit('updateNote', this._data)
            }, 100),
            saveNote() {
                EventBus.$emit('saveNote')
            },
            shareNote() {
                EventBus.$emit('shareNote', this.form.IsPublished === 1 ? 0 : 1)
            }
        },
        data () {
            return {
                format: format
            }
        },
        beforeDestroy () {
            const data = this._data
            for (let prop in data) {
                data[prop] = null
            }
            EventBus.$emit('updateNote', data)
        }
    }
</script>
<template>
    <div class="container">
        <div class="meta">
            <div class="meta-greeting"
                v-if="form.CreatedByUserID !== form.CreatedForUserID">
                <p><span>To:</span>{{to.LastName}}, {{to.FirstName}}</p>
                <p><span>From:</span>{{from.LastName}}, {{from.FirstName}}</p>
            </div>
            <div class="meta-subject">
                <p><span>Subject:</span>Thank You</p>
            </div>
            <span class="create-date">{{form.CreateDate ? format(parseInt(form.CreateDate * 1000), 'MMM. D') : format(new Date(), 'MMM. D')}}</span>
        </div>
        <div v-bind:class='{viewOnly: viewOnly}' class="section">
            <div class="sub-title">I'm grateful for...</div>
            <el-input v-model="form.PositiveFeedback" type="textarea" :rows="10"></el-input>
        </div>
        <div class="actions">
            <el-button v-if="!form.FeedBackID" class="save-btn" @click.stop="saveNote">Save</el-button>
            <el-button v-if="to.EmployeeID !== from.EmployeeID && user === form.CreatedByUserID" class="share-btn" @click.stop="shareNote">{{form.IsPublished === 1 ? `Un-Share`:`Share`}}</el-button>
        </div>
        <Comments v-if="form.FeedBackID" referencetype="note" :referenceid="form.FeedBackID"></Comments>
    </div>
</template>
<style lang="scss" scoped>
    .container {
        max-width: 780px;
        margin: 0 auto;
        .meta {
            position: relative;
            margin-bottom: 1em;
            background-color: #ffffff;
            padding: 5px;
            div p span {
                display: inline-block;
                color: #9b9b9b;
                margin-right: 5px;
            }
            .create-date {
                font-family: 'museo_sans';
                position: absolute;
                top: 1em; 
                right: 10px;
                color: #4a4a4a;
                font-size: 14px;
            }
        }
        .section {
            margin-bottom: 1em;
            .sub-title {
                font-family: 'museo_sans';
                margin-bottom: 10px;
            }
        }
        .actions {
            margin: 0px 10px 10px 0px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .save-btn, .share-btn {
            width: 130px;
            border: none;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
        }
        .save-btn {
            color: #ffffff;
            background-color: #ae94bd;
        }
        .share-btn:hover {
            background-color: #ffffff;
            color: #000000;
        }
        .viewOnly {
            pointer-events: none;
        }
        .remove {
            display: none;
        }
    }
</style>